import { useState, useEffect } from "react";
// components
import AnimationLoading from "../../components/Animationloading";
import { covertTimeZone, NewCovertTimeZone, numberFormat } from "../../helper";

// apollo-client
import { useLazyQuery } from "@apollo/client";
import { GET_REPORT_STOCK } from "../../apollo/dashboard/query";

// react-bootrap
import { Row, Table, Col, Card, Button, Form } from "react-bootstrap";

// react-apexcharts
// import ReactApexChart from "react-apexcharts";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import { startDateAndEndDate } from "../../components/handleDate";
import { GET_CATEGORYS } from "../../apollo/category/query";

export default function ReportStock() {
  let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [reportStock, setReportStock] = useState(null);
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: startDateAndEndDate().startMonth,
    createdAt_lt: startDateAndEndDate().endMonth,
  });
  const [category, setCategory] = useState("");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [activeButton, setActiveButton] = useState("thisMonth");

  const [getCategory] = useLazyQuery(GET_CATEGORYS, {
    fetchPolicy: "cache-first",
    onCompleted: (data) => {
      // console.log("🟢 Get category data success");
      if (data?.categories?.data?.length > 0) {
        setCategories(data?.categories?.data);
      } else {
        setCategories([]);
        console.log("🔴 Get category data failed");
      }
    },
  });

  // ============== > UseLazyQuery And UseMutaion <==============
  const [getReportStock, { loading }] = useLazyQuery(GET_REPORT_STOCK, {
    fetchPolicy: "cache-first",
    onCompleted: (data) => {
      // console.log("🟢 Get report stock data success", data);
      if (data?.reportStock) {
        setReportStock(data?.reportStock);
      } else {
        setReportStock(null);
        console.log("🔴 Get report stock data failed");
      }
    },
    onError: (error) => {
      console.log("🔴 Get report stock error:", error);
      setReportStock(null);
    },
  });

  useEffect(() => {
    _filter();
    getCategory({
      variables: {
        limit: 100,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  }, []);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    _filter();
  }, [cdFillter, category, debouncedSearch]);

  const _filter = async () => {
    try {
      let _where = {
        isDeleted: false,
      };

      if (category) {
        const selectedCategory = categories.find((cat) => cat.id === category);
        _where = {
          ..._where,
          category: category,
          categoryName: selectedCategory?.name,
        };
      }

      if (debouncedSearch) {
        _where = {
          ..._where,
          search: debouncedSearch,
        };
      }

      //check if filter date is set
      if (cdFillter) {
        _where = {
          ..._where,
          createdAt_gte: NewCovertTimeZone(cdFillter?.createdAt_gte),
          createdAt_lt: NewCovertTimeZone(cdFillter?.createdAt_lt),
        };
      }

      // Get report stock data
      getReportStock({
        variables: {
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error in _filter: ", error);
    }
  };

  // Chart configuration for stock visualization
  let chartState = {
    series: [
      {
        name: "ຈຳນວນສິນຄ້າ",
        data: reportStock ? [reportStock.listAmount] : [0],
      },
      {
        name: "ຍອດຂາຍ",
        data: reportStock ? [reportStock.saleAmount] : [0],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["ລາຍງານສະຕ໋ອກ"],
      },
      yaxis: {
        title: {
          text: "ຈຳນວນ",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return numberFormat(val);
          },
        },
      },
      colors: ["#1F3A60", "#20C997"],
    },
  };

  return (
    <>
      <BreadCrumbComponent txtSecond={`ລາຍງານສະຕ໋ອກ`} />
      <div style={{ padding: "0 1em" }}>
        <h4>
          <b>ລາຍງານສະຕ໋ອກສິນຄ້າ</b>
        </h4>
        <p>
          ລາຍງານສະຕ໋ອກສິນຄ້າທີ່ມີໃນຮ້ານທັງຫມົດ ແລະ
          ຍອດການຂາຍທັງຫມົດ(ຄ່າເລີ່ມຕົ້ນເປັນລາຍເດືອນ)
        </p>

        <Row>
          <Col xs={12} md={2} className="mb-3">
            <Form.Group>
              <Form.Label className="filter-label">ປະເພດ</Form.Label>
              <Form.Select
                className="filter-select"
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
                value={category}
              >
                <option value="">--ເລືອກປະເພດ--</option>
                {categories?.length > 0 &&
                  categories?.map((cat, _index) => (
                    <option key={_index} value={cat?.id}>
                      {cat?.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={2} className="mb-3">
            <Form.Group>
              <Form.Label className="filter-label">ຄົ້ນຫາ</Form.Label>
              <Form.Control
                type="text"
                placeholder="ຄົ້ນຫາສິນຄ້າ, ຊື່, barcode, suk"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={2} className="mb-3">
            <Form.Label className="filter-label">ວັນທີ, ເດືອນ, ປີ</Form.Label>
            <Button
              variant="outline-secondary"
              onClick={() => setIsCurrentModals(true)}
              style={{ minWidth: 220 }}
            >
              {!cdFillter ? (
                "mm/dd/yyyy"
              ) : (
                <>
                  {covertTimeZone(cdFillter?.createdAt_gte) +
                    " - " +
                    covertTimeZone(cdFillter?.createdAt_lt)}
                </>
              )}
            </Button>
          </Col>

          <Col xs={12} md={2} className="mb-3">
            <Form.Label className="filter-label" style={{ opacity: 0 }}>
              Actions
            </Form.Label>
            <div className="d-flex gap-2">
              <Button
                variant="outline-danger"
                onClick={() => {
                  setCategory("");
                  setSearch("");
                  setDebouncedSearch("");
                  setCdFillter({
                    createdAt_gte: startDateAndEndDate().startMonth,
                    createdAt_lt: startDateAndEndDate().endMonth,
                  });
                  setActiveButton("thisMonth");
                }}
                title="ລ້າງຕົວກອງ"
              >
                🗑️ ລ້າງ
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => _filter()}
                title="ໂຫຼດຂໍ້ມູນໃໝ່"
                disabled={loading}
              >
                {loading ? "⏳" : "🔄"} ໂຫຼດ
              </Button>
            </div>
          </Col>
        </Row>

        <br />
        {loading ? (
          <AnimationLoading />
        ) : (
          <div>
            {/* Chart Section */}
            {/* <Card style={{ padding: 8, marginTop: 10, width: "100%" }}>
              <Card.Body>
                <h5 className="mb-3">ກຣາຟສະແດງຂໍ້ມູນສະຕ໋ອກ</h5>
                <ReactApexChart
                  options={chartState.options}
                  series={chartState.series}
                  type="bar"
                  height={400}
                />
              </Card.Body>
            </Card> */}

            {/* Summary Cards */}
            <div
              style={{
                width: "100%",
                height: "auto",
                // margin: "2em 0",
              }}
            >
              <Row>
                <Col xs={12} md={12} className="mb-3">
                  <h5>
                    <b>ສະຫຼຸບຂໍ້ມູນສະຕ໋ອກ</b>
                  </h5>
                </Col>
              </Row>

              <Row className="g-4">
                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background: "#1F3A60",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(102, 126, 234, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຈຳນວນລາຍການທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>{numberFormat(reportStock?.listTotal || 0)}</b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background:
                        "#f093fb",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(240, 147, 251, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຈຳນວນສິນຄ້າໃນສະຕ໋ອກ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>{numberFormat(reportStock?.listAmount || 0)}</b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background:
                        "#1F3A60",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(79, 172, 254, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ມູນຄ່າສິນຄ້າໃນສະຕ໋ອກ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>
                          {numberFormat(parseInt(reportStock?.listPrice) || 0)}{" "}
                          <span style={{ fontSize: "1.2rem" }}>₭</span>
                        </b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background: "#20C997",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(67, 233, 123, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຍອດຂາຍລາຍການທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>{numberFormat(reportStock?.saleAmount || 0)}</b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background:
                        "#a8edea",
                      color: "#2c3e50",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(168, 237, 234, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.8" }}>
                        ຍອດຂາຍຈຳນວນທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>{numberFormat(reportStock?.saleTotal || 0)}</b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background: "#FFC107",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(250, 112, 154, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຍອດຂາຍເງີນທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>
                          {numberFormat(parseInt(reportStock?.salePrice) || 0)}{" "}
                          <span style={{ fontSize: "1.2rem" }}>₭</span>
                        </b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background:
                        "#1F3A60",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(41, 235, 173, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຈຳນວນລາຍການທີ່ແຖມທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>{numberFormat(reportStock?.amountFreeTotal || 0)}</b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background:
                        "#20C997",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(105, 253, 238, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຈຳນວນທີ່ແຖມທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>
                          {numberFormat(reportStock?.amountFreeAmount || 0)}
                        </b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} sm={6} md={4} lg={3} xl={2} className="mb-3">
                  <Card
                    className="text-center h-100 shadow-sm border-0"
                    style={{
                      background:
                        "#1F3A60",
                      color: "white",
                      borderRadius: "15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 25px rgba(140, 205, 235, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <h6 className="mb-3" style={{ fontSize: "0.9rem", fontWeight: "500", opacity: "0.9" }}>
                        ຈຳນວນເງິນທີ່ແຖມທັງໝົດ
                      </h6>
                      <h4 className="mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        <b>
                          {numberFormat(reportStock?.amountFreePrice || 0)}{" "}
                          <span style={{ fontSize: "1.2rem" }}>₭</span>
                        </b>
                      </h4>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Detailed Table */}
              <Card
                style={{
                  padding: "1em",
                  width: "100%",
                  height: "auto",
                  marginTop: "2em",
                }}
              >
                <div style={{ width: "100%", height: "auto" }}>
                  <h5 className="mb-3">ລາຍລະອຽດຂໍ້ມູນສະຕ໋ອກ</h5>
                  <Table striped hover responsive>
                    <thead
                      style={{
                        background:
                          "#1F3A60",
                        color: "white",
                        fontWeight: "400",
                      }}
                    >
                      <tr>
                        <th>ລາຍການ</th>
                        <th>ຄ່າ</th>
                        <th>ຄຳອະທິບາຍ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <b>📋ຈຳນວນລາຍການທັງໝົດ</b>
                        </td>
                        <td>{numberFormat(reportStock?.listTotal || 0)}</td>
                        <td>🧮ຈຳນວນລາຍການສິນຄ້າທັງໝົດໃນລະບົບ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>📊ຈຳນວນສິນຄ້າໃນສະຕ໋ອກ</b>
                        </td>
                        <td>{numberFormat(reportStock?.listAmount || 0)}</td>
                        <td>🧮ຈຳນວນສິນຄ້າທີ່ມີຢູ່ໃນສະຕ໋ອກ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>💸ມູນຄ່າສິນຄ້າໃນສະຕ໋ອກ</b>
                        </td>
                        <td>
                          {numberFormat(parseInt(reportStock?.listPrice) || 0)}{" "}
                          ₭
                        </td>
                        <td>🧮ມູນຄ່າລວມຂອງສິນຄ້າທີ່ມີໃນສະຕ໋ອກ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>📋ຍອດຂາຍລາຍການທັງໝົດ</b>
                        </td>
                        <td>{numberFormat(reportStock?.saleAmount || 0)}</td>
                        <td>✅ຍອດຂາຍລວມ ລາຍການທັງຫມົດທີ່ຂາຍໄປ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>📊ຍອດຂາຍຈຳນວນທັງໝົດ</b>
                        </td>
                        <td>
                          {numberFormat(parseInt(reportStock?.saleTotal) || 0)}
                        </td>
                        <td>✅ຍອດຂາຍລວມ ຈຳນວນສີນຄ້າທັງໝົດ ທີ່ຂາຍໄປ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>💸ຍອດຂາຍລາຍການທັງໝົດ</b>
                        </td>
                        <td>
                          {numberFormat(parseInt(reportStock?.salePrice) || 0)}{" "}
                          ₭
                        </td>
                        <td>✅ມູນຄ່າຍອດຂາຍ ຈຳນວນເງີນທັງໝົດ ທີ່ຂາຍໄປ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>📋ຈຳນວນລາຍການທີ່ແຖມທັງໝົດ</b>
                        </td>
                        <td>
                          {numberFormat(
                            parseInt(reportStock?.amountFreeTotal) || 0
                          )}
                        </td>
                        <td>📝ຈຳນວນລາຍການຂາຍ ທີ່ແຖມສິນຄ້າ ໄປທັງໝົດ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>📊ຈຳນວນທີ່ແຖມທັງໝົດ</b>
                        </td>
                        <td>
                          {numberFormat(
                            parseInt(reportStock?.amountFreeAmount) || 0
                          )}
                        </td>
                        <td>📝ຈຳນວນສິນຄ້າທີ່ແຖມລວມທັງໝົດ</td>
                      </tr>
                      <tr>
                        <td>
                          <b>💸ຈຳນວນເງິນທີ່ແຖມທັງໝົດ </b>
                        </td>
                        <td>
                          {numberFormat(
                            parseInt(reportStock?.amountFreePrice) || 0
                          )}{" "}
                          ₭
                        </td>
                        <td>📝ມູນຄ່າຍອດເງິນລວມ ຂອງສິນຄ້າທີ່ແຖມໄປ ທັງໝົດ</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card>
            </div>
          </div>
        )}
      </div>

      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </>
  );
}
